import * as React from "react";

export interface PreviewModeContextType {
    handlePreviewModeSubmitButtonClick: () => void;
    isPreviewMode: boolean;
}

export const PreviewModeContext = React.createContext<
    PreviewModeContextType | undefined
>(undefined);
